import type { Blueprint } from '@builder/base/blueprints/Blueprint';
import type { HasWidth } from '@builder/base/traits/HasWidth';
import type { BlueprintDefinition } from '@builder/form/blueprints/BlueprintDefinition';

export const Definition: BlueprintDefinition = {
    type: 'spacer',
    name: '[[[Odstęp]]]',
    icon: 'fa-arrows-alt-h',
    group: 'primary',
    position: 9
};

export interface SpacerContract extends Blueprint, HasWidth
{
}

export class SpacerType implements SpacerContract
{
    public id: string;
    public type: string;
    public name: string;
    public minWidth: number;
    public width: number;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.minWidth = 1;
        this.width = 0;
    }

    public setDefaultWidth(width: number): void
    {
        this.width = Math.max(this.minWidth, width);
    }
}
